import { render, staticRenderFns } from "./CreateTemplate.vue?vue&type=template&id=5ff1abe8&"
import script from "./CreateTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports